import HeaderTitle from "@shared-ui-components/HeaderTitle";

import CustomDataTable from "../CustomDataTable";
import { StyledRootBox } from "./styles";
import { DataTableProps } from "./types";

const DataTable = ({
  rowData,
  isLoading,
  title,
  sortBy,
  sortHandler,
  handleTypeChange,
  showPagination,
  handlePageChange,
  dyColumns,
  dropDownOptions,
  type,
  page,
  handleNavigate,
}: DataTableProps) => {
  return (
    <StyledRootBox>
      <HeaderTitle
        title={title}
        handleChange={handleTypeChange}
        value={type}
        options={dropDownOptions?.map((el) => el.label)}
      />
      <CustomDataTable
        rowData={rowData}
        isLoading={isLoading}
        sortBy={sortBy}
        showPagination={showPagination}
        handlePageChange={handlePageChange}
        dyColumns={dyColumns}
        page={page}
        handleNavigate={handleNavigate}
        sortHandler={sortHandler}
      />
    </StyledRootBox>
  );
};

export default DataTable;
